export const tableColumn = () => {
  return [
    // { type: 'checkbox', width: 50 },
    // { type: 'seq', title: '序号', width: 50 },
    {
      field: 'expenseNo',
      title: '费用编号',
      width: 120,
    },
    // {
    //   field: 'createMethod',
    //   title: '创建方式',
    //   width: 100,
    // },
    {
      field: 'expenseGenerationDate',
      title: '费用生成日期',
      width: 120,
    },
    // {
    //   field: 'businessCompanyName',
    //   title: '公司名称',
    //   width: 120,
    // },
    // {
    //   field: 'businessDepartmentName',
    //   title: '部门名称',
    //   width: 150,
    // },
    // {
    //   field: 'supplierName',
    //   title: '供应商名称',
    //   width: 120,
    // },
    // {
    //   field: 'contractNo',
    //   title: '合同编号',
    //   width: 120,
    // },
    {
      field: 'accountPeriod',
      title: '应付账期',
      width: 150,
    },
    // {
    //   field: 'settlementBusinessType',
    //   title: '业务类别',
    //   width: '150',
    // },
    {
      field: 'expenseType',
      title: '费用类型',
      width: 150,
    },
    {
      field: 'originalPrice',
      title: '结算单价(含税)',
      width: 150,
    },

    {
      field: 'settlementQuantity',
      title: '结算数量',
      width: 120,
    },
    {
      field: 'unit',
      title: '计量单位',
      width: 120,
    },
    {
      field: 'originalAmount',
      title: '原币结算金额(含税)',
      width: 180,
    },

    {
      field: 'currencyName',
      title: '币种',
      width: 120,
    },
    {
      field: 'exchangeRate',
      title: '汇率',
      width: 100,
    },
    {
      field: 'domesticAmount',
      title: '本币结算金额(含税)',
      width: 150,
    },
    {
      field: 'periodDateFrom',
      title: '业务结算日期从',
      width: 150,
    },
    {
      field: 'periodDateUntil',
      title: '业务结算日期至',
      width: 150,
    },
    // {
    //   field: 'processStatus',
    //   title: '状态',
    //   width: 120,
    // },
    {
      field: 'businessDocNo',
      title: '业务单据编码',
      width: 120,
    },
    {
      field: 'spaceType',
      title: '空间类型',
      width: 120,
    },
    {
      field: 'spaceCategory',
      title: '空间类别',
      width: 120,
    },
    {
      field: 'builtArea',
      title: '面积',
      width: 120,
    },
    // {
    //   field: 'payableSettlementNo',
    //   title: '结算单编号',
    //   width: 120,
    // },
    // {
    //   field: 'salesmanName',
    //   title: '业务员',
    //   width: 120,
    // },
  ];
};
